import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultImageDirective } from './default-image.directive';
import { IsLanguageAgnosticDirective } from './is-language-agnostic.directive';

@NgModule({
    declarations: [DefaultImageDirective, IsLanguageAgnosticDirective],
    imports: [CommonModule],
    exports: [DefaultImageDirective, IsLanguageAgnosticDirective],
})
export class DirectiveModule {}
